(function () {
    'use strict';

    angular
        .module('sempraWebapp')
        .controller('RolloverVouchersReportController', RolloverVouchersReportController);

    /** @ngInject */
    function RolloverVouchersReportController(
        $scope,
        $timeout,
        $translate,
        $filter,
        dashboardKarcherActions,
        layoutActions,
        exportToCsv,
        helperService
    ) {
        var vm = this;
        var chart = null;

        vm.sites = [];
        vm.selectedSiteId = null;
        vm.dateFrom = new Date(new Date().setDate(new Date().getDate() - 30));
        vm.dateTo = new Date();
        vm.timeUnit = 'DAY';
        vm.isLoading = false;
        vm.stats = null;
        vm.selectedReportType = 'washesSold';

        vm.onSiteChange = onSiteChange;
        vm.loadStats = loadStats;
        vm.updateChart = updateChart;
        vm.exportToCsv = exportToCsvReport;

        init();

        function init() {
            $scope.$on('$destroy', onDestroyHandler);
            loadSites();
        }

        function loadSites() {
            layoutActions.showLoader();
            dashboardKarcherActions.getKarcherSitesData('', '').then(
                function (response) {
                    vm.sites = response.siteAlarmStatusDtos || [];
                    if (vm.sites.length > 0) {
                        vm.selectedSiteId = vm.sites[0].siteId;
                    }
                    layoutActions.hideLoader();
                },
                function () {
                    vm.sites = [];
                    layoutActions.hideLoader();
                }
            );
        }

        function onSiteChange() {
            vm.stats = null;
            if (chart) {
                chart.destroy();
                chart = null;
            }
        }

        function loadStats() {
            if (!vm.selectedSiteId) return;

            vm.isLoading = true;
            layoutActions.showLoader();

            var since = vm.dateFrom.getTime();
            var to = vm.dateTo.getTime() + (24 * 60 * 60 * 1000); // Include end date

            dashboardKarcherActions.getRolloverVoucherStats(vm.selectedSiteId, since, to, vm.timeUnit).then(
                function (response) {
                    vm.stats = response;
                    vm.isLoading = false;
                    layoutActions.hideLoader();
                    $timeout(function () {
                        updateChart();
                    }, 100);
                },
                function () {
                    vm.stats = null;
                    vm.isLoading = false;
                    layoutActions.hideLoader();
                }
            );
        }

        function updateChart() {
            if (!vm.stats || !vm.stats.labels) return;

            if (chart) {
                chart.destroy();
                chart = null;
            }

            var chartData = buildChartData();
            
            chart = c3.generate({
                bindto: '#rolloverVouchersChart',
                data: {
                    x: 'x',
                    columns: chartData.columns,
                    type: 'bar',
                    groups: [chartData.groups]
                },
                bar: {
                    width: {
                        ratio: 0.6
                    }
                },
                axis: {
                    x: {
                        type: 'category',
                        tick: {
                            rotate: 45,
                            multiline: false
                        },
                        height: 80
                    },
                    y: {
                        label: {
                            text: getYAxisLabel(),
                            position: 'outer-middle'
                        }
                    }
                },
                legend: {
                    position: 'right'
                },
                size: {
                    height: 350
                }
            });
        }

        function getYAxisLabel() {
            switch (vm.selectedReportType) {
                case 'washesSold': return $translate.instant('ROLLOVER_WASHES_SOLD');
                case 'washesPerformed': return $translate.instant('ROLLOVER_WASHES_PERFORMED');
                case 'washesNotPerformed': return $translate.instant('ROLLOVER_WASHES_NOT_PERFORMED');
                case 'washesExpired': return $translate.instant('ROLLOVER_WASHES_EXPIRED');
                case 'optionsSold': return $translate.instant('ROLLOVER_OPTIONS_SOLD');
                case 'revenue': return $translate.instant('ROLLOVER_REVENUE');
                default: return '';
            }
        }

        function buildChartData() {
            var columns = [];
            var groups = [];
            
            // Add x-axis labels
            columns.push(['x'].concat(vm.stats.labels));

            if (vm.selectedReportType === 'washesSold') {
                vm.stats.programStats.forEach(function (program) {
                    var columnData = [program.programName].concat(program.washesSold);
                    columns.push(columnData);
                    groups.push(program.programName);
                });
            } else if (vm.selectedReportType === 'washesPerformed') {
                vm.stats.programStats.forEach(function (program) {
                    var columnData = [program.programName].concat(program.washesPerformed);
                    columns.push(columnData);
                    groups.push(program.programName);
                });
            } else if (vm.selectedReportType === 'washesNotPerformed') {
                vm.stats.programStats.forEach(function (program) {
                    var columnData = [program.programName].concat(program.washesNotPerformed);
                    columns.push(columnData);
                    groups.push(program.programName);
                });
            } else if (vm.selectedReportType === 'washesExpired') {
                vm.stats.programStats.forEach(function (program) {
                    var columnData = [program.programName].concat(program.washesExpired);
                    columns.push(columnData);
                    groups.push(program.programName);
                });
            } else if (vm.selectedReportType === 'optionsSold') {
                if (vm.stats.optionStats) {
                    vm.stats.optionStats.forEach(function (option) {
                        var columnData = [option.optionName].concat(option.optionsSold);
                        columns.push(columnData);
                        groups.push(option.optionName);
                    });
                }
            } else if (vm.selectedReportType === 'revenue') {
                vm.stats.programStats.forEach(function (program) {
                    var columnData = [program.programName].concat(program.revenue);
                    columns.push(columnData);
                    groups.push(program.programName);
                });
            }

            return {
                columns: columns,
                groups: groups
            };
        }

        function exportToCsvReport() {
            if (!vm.stats) return;

            var selectedSite = vm.sites.find(function (site) {
                return site.siteId === vm.selectedSiteId;
            });

            var fileTitleData = [
                $translate.instant('ROLLOVER_VOUCHERS_REPORT'),
                selectedSite ? selectedSite.siteName : '',
                $filter('date')(vm.dateFrom, 'dd-MM-yyyy'),
                $filter('date')(vm.dateTo, 'dd-MM-yyyy')
            ];

            var csvData = [];

            // Header row
            csvData.push({
                date: $translate.instant('DATE'),
                washesSold: $translate.instant('ROLLOVER_WASHES_SOLD'),
                washesPerformed: $translate.instant('ROLLOVER_WASHES_PERFORMED'),
                washesNotPerformed: $translate.instant('ROLLOVER_WASHES_NOT_PERFORMED'),
                washesExpired: $translate.instant('ROLLOVER_WASHES_EXPIRED'),
                revenue: $translate.instant('ROLLOVER_REVENUE')
            });

            // Data rows
            vm.stats.labels.forEach(function (label, index) {
                csvData.push({
                    date: label,
                    washesSold: vm.stats.totals.totalWashesSold[index],
                    washesPerformed: vm.stats.totals.totalWashesPerformed[index],
                    washesNotPerformed: vm.stats.totals.totalWashesNotPerformed[index],
                    washesExpired: vm.stats.totals.totalWashesExpired[index],
                    revenue: vm.stats.totals.totalRevenue[index]
                });
            });

            // Totals row
            csvData.push({
                date: $translate.instant('TOTAL'),
                washesSold: vm.stats.totals.grandTotalSold,
                washesPerformed: vm.stats.totals.grandTotalPerformed,
                washesNotPerformed: vm.stats.totals.grandTotalNotPerformed,
                washesExpired: vm.stats.totals.grandTotalExpired,
                revenue: vm.stats.totals.grandTotalRevenue
            });

            exportToCsv.export(
                csvData,
                helperService.createFileName(fileTitleData),
                true
            );
        }

        function onDestroyHandler() {
            if (chart) {
                chart.destroy();
                chart = null;
            }
        }
    }
})();
